<template>
    <v-btn v-if="isLoggedIn && url" variant="text" :href="url" :class="{ 'v-btn--slim': colorTheme == 'inverted' }" class="logout-link">
        <template #prepend>
            <v-sheet
                rounded="circle"
                width="20"
                height="20"
                class="d-flex align-center justify-center"
                :class="{ 'v-btn--highlighted': colorTheme == 'inverted' }"
            >
                <v-icon icon="mdi-logout" size="18" :color="colorTheme == 'inverted' ? 'white' : 'green'" />
            </v-sheet>
        </template>
        {{ title }}
    </v-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { MenuStructure, useSiteNavigation } from '../../composables';

interface Props {
    menuItems: MenuStructure;
    isLoggedIn: boolean;
    colorTheme?: string;
    currentLanguage: string;
}

const props = defineProps<Props>();
const { logoutLink } = useSiteNavigation(props);

const url = computed(() => {
    if (props.isLoggedIn && logoutLink.value) return logoutLink.value.link;

    return undefined;
});

const title = computed(() => { return logoutLink.value?.displayName || '';});
</script>

<style lang="scss">
@use 'vuetify/settings' as *;

.logout-link.v-btn {
    color: var(--v-color-white);
    text-transform: none;

    .v-btn--highlighted {
        background-color: var(--v-color-green-darken-1);
    }

    .v-btn__prepend {
        i {
            margin-left: 2px;
            font-size: 14px !important;
        }
    }
}
</style>
